import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { projectsService } from '../api/projects.service';
import { PROJECT_KEYS } from './queryKeys';

export function useUploadProjectIcon() {
  const queryClient = useQueryClient();
  const orgId = useOrganizationStore((s) => s.activeOrganizationId);
  return useMutation({
    mutationFn: ({ projectId, file }: { projectId: string; file: File }) =>
      projectsService.uploadAvatar(projectId, file),
    onSuccess: (_, { projectId }) => {
      queryClient.invalidateQueries({
        queryKey: PROJECT_KEYS.detail(orgId ?? '', projectId),
      });
    },
  });
}
